<template>
  <div class="sm-notification-top terms">
    <div class="sm-wrap">
      <div class="sm-notification-top__terms" @click="handleClick">
        <include-svg :name="'icon-warning-sys'" />
        <span class="sm-small">
          Connect Deskworks — 
          <a
            class="sm-txt-small"
            target="_blank"
            href="https://support.spheremail.co/support/solutions/articles/69000834255-linking-deskworks-to-your-spheremail-portal%E2%86%92"
          >
            Learn more
          </a>
        </span>
        <a
          href="#"
          class="sm-notification-top__terms-close"
          @click.stop="$emit('close')"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "deskworks-notification",
  methods: {
    handleClick() {
      this.$router.push("/admin/settings?tab=other&view=systems");

      this.$emit("close");
    },
  },
};
</script>